import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Dropdown } from 'semantic-ui-react';

/**
 * Components InputSelectText
 * Retourne jsx d'un select
 * @param {string} props.name
 * @param {string} props.value
 * @param {string} props.placeholder
 * @param {array} props.data
 * @param {bool} props.search
 * @param {bool} props.compact
 * @param {bool} props.required
 * @param {bool} props.error
 * @param {bool} props.disabled
 */
const InputSelectText = (props) => {
  const [globalContext] = useContext(GlobalContext);
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    }
  }, [globalContext.translations, props.value])

  /**
   * Event lorsque la valeur de l'input change
   */
  const handleChange = (event, {value}) => {
    if (props.handleChange) {
      props.handleChange({
        target : {
          name: props.name,
          value: value
        }
      });
    }
    setValue(value);
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <div className="divDropdown">
      <Dropdown
        selection
        placeholder={props.placeholder}
        options={props.data}
        value={value}
        search={props.search}
        onChange={handleChange}
        compact={props.compact}
        required={props.required}
        fluid
        error={props.error}
        disabled={props.disabled}
      >
      </Dropdown>
      <input type="hidden" name={props.name} value={value} />
    </div>
  )
}

export default InputSelectText;
